<template>
  <div>
    <px-view-header title="Alçadas de solicitação" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div class="mt-5" v-else>
      <px-alcadas-list :alcadas="alcada"
                       :opcoes-criterios="opcoesCriterios"
                       :loading-save="loadingSave"
                       :loading-remove="loadingRemove"
                       @save="onClickSave"
                       @remove="onClickRemove"/>
    </div>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import AlcadasList from '@/modules/alcadas/components/AlcadasList.vue';
import { CriteriosAprovacaoSolicitacao } from 'px-business-components';
import AlcadasRequisicaoService from '@/modules/alcadas/alcadas-requisicao-service';

export default {
  data() {
    return {
      loading: false,
      loadingSave: false,
      loadingRemove: false,
      alcada: null,
      opcoesCriterios: CriteriosAprovacaoSolicitacao.values,
      breadcrumbs: [
        { text: 'Configurações' },
        { text: 'Alçadas de solicitação' },
      ],
    };
  },
  methods: {
    getAlcadas() {
      this.loading = true;
      AlcadasRequisicaoService.get()
        .then(({ data }) => {
          this.alcada = data || null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildCriterios(criterio) {
      return {
        $$id: undefined,
        id: criterio.id ?? undefined,
        campo: criterio.campo,
        values: criterio.values.map((value) => {
          if (typeof value === 'object') {
            return { id: value.id };
          }
          return value;
        }),
      };
    },
    buildPayload(payload) {
      const { regras, criaHierarquia } = payload;
      return {
        id: this.alcada ? this.alcada.id : undefined,
        regras: regras.map((regra, index) => ({
          ...regra,
          $$id: undefined,
          sequencia: index + 1,
          criterios: regra.criterios.map(this.buildCriterios),
        })),
        criaHierarquia,
      };
    },
    onClickSave(payload) {
      this.loadingSave = true;
      this.saveFunction(payload)
        .then(() => {
          this.$toast.success('Alçadas atualizadas');
          this.getAlcadas();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    saveFunction(payload) {
      if (this.alcada) {
        return AlcadasRequisicaoService.update(this.alcada.id, this.buildPayload(payload));
      }
      return AlcadasRequisicaoService.create(this.buildPayload(payload));
    },
    onClickRemove() {
      this.$refs.confirm.open('Você deseja remover essa configuração?',
        'Esta operação não pode ser desfeita',
        { width: 400 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.removeAlcadas();
        });
    },
    removeAlcadas() {
      this.loadingRemove = true;
      AlcadasRequisicaoService.remove(this.alcada.id)
        .then(() => {
          this.$toast.success('Alçadas removidas');
          this.getAlcadas();
        })
        .finally(() => {
          this.loadingRemove = false;
        });
    },
  },
  created() {
    this.getAlcadas();
  },
  components: {
    pxAlcadasList: AlcadasList,
  },
};
</script>
